import { gql } from '@apollo/client';

export const FETCH_ALL_PROVIDERS = gql`
query fetchAllPractitioners(
  $sourceUrl: String
  $count: String
  $offset: Int
  $language: String
  $speciality: String
  $searchFilter: String
  ){
    fetchAllPractitioners(
  sourceUrl: $sourceUrl
  count: $count
  offset: $offset
  language: $language
  speciality: $speciality
  searchFilter: $searchFilter
    ){
      practitionerList
      count
    }
  }
`;

export const FETCH_PROVIDERS_BY_ID = gql`
  query fetchProviderById($providerId: String) {
    fetchProviderById(providerId: $providerId) {
      id
      name {
        family
        given
      }
      telecom {
        value
        system
      }
      communication {
        text
      }
      active
    }
  }
`;

export const FETCH_PREVIOUSLY_VISITED_CARD = gql`
  query fetchAllPreviouslyVisited(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllPreviouslyVisited(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      visitsList
      count
    }
  }
`;

export const FETCH_TIME_SLOT_QUERY = gql`
query fetchSlotByPractitionerId($practitionerId: String) {
  fetchSlotByPractitionerId(practitionerId: $practitionerId) {
    id
    status
    startDate
    endDate
  }
}
`;
